<template>
  <section class="news-section">
    <div
      class="first-section"
      :class="`bg-${background}`"
    >
      <div>
        <h1
          class="section-title"
          v-html="sectionTitle"
        ></h1>
        <h1
          class="section-title-md"
          v-html="sectionTitleMd || sectionTitle"
        ></h1>
      </div>
      <div class="nav-buttons">
        <div class="dots">
          <div
            v-for="(article, index) in articles"
            :key="index"
            class="dot"
            :class="dataItems.index === index && 'active'"
          ></div>
        </div>
        <div class="chevrons">
          <button
            class="chevron-left"
            :class="dataItems.index === 0 && 'disabled'"
            aria-label="prev"
            @click="setActiveItem('prev')"
          >
            <ChevronLeftIcon :stroke-width="3" />
          </button>
          <button
            class="chevron-right"
            :class="dataItems.index === articles.length - 2 && 'disabled'"
            aria-label="next"
            @click="setActiveItem('next')"
          >
            <ChevronRightIcon />
          </button>
        </div>
      </div>
    </div>
    <div class="events-container">
      <div
        ref="carousel"
        class="events"
        :style="`left:${dataItems.left}`"
      >
        <div
          v-for="(article, index) in articles"
          :key="article.id"
          ref="articleRef"
          class="event"
          @click="openArticle(article, index)"
        >
          <div class="event-wrapper">
            <div class="event-image-wrapper">
              <img
                :src="articleImage(article.image)"
                :alt="article.title"
                class="event-image"
              />
            </div>
            <div class="event-date">
              {{ article.published_at }}
              <template v-if="article.read_time">
                · {{ article.read_time }}
              </template>
            </div>
            <h4 class="event-title">{{ article.title }}</h4>

            <div class="tags">
              <div
                v-for="(tag, key) in article.tags"
                :key="key"
                class="event-tag"
              >
                {{ tag }}
              </div>
            </div>
          </div>
          <ReadMore />
        </div>
      </div>
    </div>
    <div
      class="nav-buttons nav-buttons-mobile"
      :class="`bg-${background}`"
    >
      <div class="dots">
        <div
          v-for="(article, index) in articles"
          :key="index"
          class="dot"
          :class="dataItems.index === index && 'active'"
        ></div>
      </div>
      <div class="chevrons">
        <button
          class="chevron-left"
          :class="dataItems.index === 0 && 'disabled'"
          aria-label="prev"
          @click="setActiveItem('prev')"
        >
          <ChevronLeftIcon :stroke-width="3" />
        </button>
        <button
          class="chevron-right"
          :class="dataItems.index === articles.length - 2 && 'disabled'"
          aria-label="next"
          @click="setActiveItem('next')"
        >
          <ChevronRightIcon />
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import ChevronLeftIcon from '~/components/Common/Svg/ChevronLeftIcon.vue';
import ChevronRightIcon from '~/components/Common/Svg/ChevronRightIcon.vue';
import ReadMore from '~/components/Common/ReadMore/ReadMore';
import carousel from '~/mixins/carousel';
import cloudinaryImage from '~/utils/helpers/cloudinaryImage';

export default {
  components: {
    ChevronRightIcon,
    ChevronLeftIcon,
    ReadMore,
  },
  mixins: [carousel],
  props: {
    sectionTitle: {
      type: String,
      required: true,
    },
    sectionTitleMd: {
      type: String,
      default: '',
    },
    articles: {
      type: Array,
      required: true,
    },
    background: {
      type: String,
      default: 'dark',
    },
  },
  methods: {
    openArticle(article, index) {
      const url = `article/${article.slug}`;
      this.$analytics.track('News Section', {
        action: 'Article Click',
        article_url: url,
        position: index + 1,
        page_name: this.$route.name === 'index' ? 'homepage' : this.$route.name,
      });
      this.$router.push(url);
    },
    setActiveItem(direction, isMobile = false) {
      const currentIndex = this.dataItems.index;
      const articleWidth = this.$refs.articleRef[0].clientWidth;
      const lastIndex = this.articles.length - (isMobile ? 1 : 2);
      const newIndex =
        direction === 'next' ? currentIndex + 1 : currentIndex - 1;
      const increment = direction === 'next' ? -1 : 1;

      if (newIndex < 0 || newIndex > lastIndex) {
        return;
      }

      this.dataItems = {
        left: `${this.dataItems.value + increment * articleWidth}px`,
        value: this.dataItems.value + increment * articleWidth,
        index: newIndex,
        transition: '0.6s',
      };

      const pageName =
        this.$route.name === 'index' ? 'homepage' : this.$route.name;
      this.$analytics.track('News Section', { direction, page_name: pageName });
    },
    articleImage(image) {
      return image
        ? cloudinaryImage({
            imagePath: image,
            width: 1200,
          })
        : '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import './NewsSection.scss';
</style>
